<div
  id="probabilityCalculatorForm"
  [ngStyle]="{'height': isFuturesMonitor ? '90%' : '81%'}"
>

  <ngx-spinner
    [fullScreen]="false"
    bdColor="rgba(51,51,51,0.1)"
    bdOpacity=0.5
    color="#fff"
    name=probabilityCalculatorSpinner
    size="medium"
    type="ball-spin-clockwise"
  >
    <p style="color: white"></p>
  </ngx-spinner>

  <iv-live-common-calculator
    [ngStyle]="isLoading ? {'filter':'blur(10px)'}: null"

    (changeInstrument)="changeInstrument($event)"
    (goButtonClicked)="onGoButtonClick($event)"
    (hideSpinnerEvent)="hideSpinner()"
    (keyDownSearch)="keyDownSearch($event)"
    (modeClicked)="onModeChanged($event)"
    (returnRegionEvent)="returnRegion($event)"
    (showSpinnerEvent)="showSpinner()"
    [autocompletePlaceholder]="isFuturesMonitor ? 'Future or Option Symbol...' : 'Stock, Index or Option Symbol...'"

    [instruments]="instruments"
    [regionId]="regionId"
    [stockSearchCriteria]="id"
    [stockName]="instrument?.nameAndExchange || instrument?.stockName || id"
    [value]="instrument?.value"
    style="width: 400px;"
  >
    <div class="calculator-body">

      <div class="parameters">
        <!-- Заглушка, которая занимает место для search (вынужденное решение в связи с предыдущей реализацией) -->
        <div class="param" style="opacity:0; visibility: hidden;">
          <span class="param-label"></span>
          <span class="param-value"></span>
        </div>
        <div class="param" *ngIf="isFuturesMonitor">
          <span class="param-label with-tip">FutExp
            <span class="tip">Ending date of the Futures contract</span>
          </span>
          <iv-live-dropdown
            (closeOtherDropdown)="openDropdown(0)"
            (scroll)="onScroll($event)"
            (selectedDataChange)="selectFutExpiration($event)"
            [cssClass]="'param-value param-value-style'"
            [data]="getArrayFromObject(futureExpirations)"
            [label]=""
            [selectedData]="futExpDate"
            [type]="getTypeDropDown()"
            data-id="expirations"
          >
          </iv-live-dropdown>
        </div>

        <div class="param">
          <span class="param-label with-tip">Last Price
            <span class="tip">{{isFuturesMonitor ? 'Futures Last Price' : 'Stock Last Price / Index Value'}}</span>
          </span>
          <input
            (input)="onlyNumbersPaste($event)"
            (keydown)="keyDown($event)"
            (keypress)="onlyNumberKey($event)"
            [(ngModel)]="price"
            (ngModelChange)="inputHandler($event)"
            [ngModelOptions]="{standalone: true}"
            class="param-value"
            data-id="price"
          >
        </div>

        <div class="param">
        <span class="param-label with-tip">Interest Rate
          <span class="tip">The interest rate used is derived from last night's treasury market and is
            interpolated to conform to option's expiration term.
            We take OIS SOFR for terms up to one year inclusive and ISDA (R)
            Swaps IR par mid rate for terms above one year</span>
        </span>
          <input
            (input)="onlyNumbersPaste($event)"
            (keydown)="keyDown($event)"
            (keypress)="onlyNumberKey($event)"
            [(ngModel)]="rate"
            (ngModelChange)="inputHandler($event)"
            [ngModelOptions]="{standalone: true}"
            class="param-value"
            data-id="rate"
          >
        </div>

        <div class="param">
      <span class="param-label with-tip">Expiry
          <span class="tip">Option expiry; closest expiry set by default</span>
        </span>
          <div style="display: flex; gap:8px; width:252px;">
            <div style="width: 180px;">
              <iv-live-dropdown
                (closeOtherDropdown)="openDropdown(isFuturesMonitor? 1 : 0)"
                (selectedDataChange)="selectExpiration($event)"
                [cssClass]="'param-value param-value-style'"
                [data]="getArrayFromObject(expirations)"
                [label]=""
                [selectedData]="expDate"
                [type]="getTypeDropDown()"
                [valueAttribute]="'expDate'"
                data-id="expDate"
                [dropdownOffset]="{'top': '36px', 'bottom': 'auto'}"
              >
              </iv-live-dropdown>
            </div>

            <div *ngIf="!isFuturesMonitor" style="width: 64px">
              <input
                class="param-value expiry-hours-value"
                data-id="hoursExp"
                readonly
                value="{{getHours()}}"
              >
            </div>

          </div>
        </div>

        <div
          *ngIf="!isFuturesMonitor"
          [style.visibility]="(stockType === 'I' || stockType === 'X')? 'hidden': 'visible'"
          class="param"
        >
        <span class="param-label with-tip">Dividend Date
          <span class="tip">Dividend Date. Stock/ETF's nearest prior announced dividend date</span>
        </span>
          <input
            (input)="dateValidate($event)"
            (keydown)="keyDown($event)"
            [(ngModel)]="lastDividendDate"
            (ngModelChange)="inputHandler($event)"
            [ngModelOptions]="{standalone: true}"
            [textMask]="{mask: dateMask}"
            class="param-value"
            data-id="lastDividendDate"
            name="date"
            placeholder="YYYY-MM-DD"
            type="text"
            value="{{lastDividendDate}}"
          >
        </div>

        <div class="param">
        <span class="param-label with-tip">{{!isFuturesMonitor ? 'Time to expiration' : 'DTE'}}
          <span class="tip">
            {{!isFuturesMonitor
              ? 'Days, hours, minutes remaining to expiry; you can change this to analyze a nonstandard option or perform what -if analysis'
              : 'Days to Expiration'
            }}
          </span>
        </span>
          <div class="time-values">
            <input
              (input)="onExpValueInput($event, 'daysToExp')"
              (keydown)="keyDown($event)"
              (keypress)="onlyNumberKey($event)"
              class="param-value"
              data-id="daysToExp"
              value="{{daysToExp}}"
              placeholder="D-"
            >
            <input
              *ngIf="!isFuturesMonitor"
              (input)="onExpValueInput($event, 'hours')"
              (keydown)="keyDown($event)"
              (keypress)="onlyNumberKey($event)"
              class="param-value"
              data-id="hoursToExp"
              value="{{hours}}"
              placeholder="H-"
            >
            <input
              *ngIf="!isFuturesMonitor"
              (input)="onExpValueInput($event, 'minutes')"
              (keydown)="keyDown($event)"
              (keypress)="onlyNumberKey($event)"
              class="param-value"
              data-id="minToExp"
              value="{{minutes}}"
              placeholder="Min-"
            >
          </div>
        </div>

        <div
          *ngIf="!isFuturesMonitor"
          [style.visibility]="(stockType === 'I' || stockType === 'X')? 'hidden': 'visible'"
          class="param"
        >
        <span class="param-label with-tip">Dividend Amount
          <span class="tip">Dividend Amount. Stock/ETF's dividend amount</span>
        </span>
          <input
            (input)="onlyNumbersPaste($event)"
            (keydown)="keyDown($event)"
            (keypress)="onlyNumberKey($event)"
            [(ngModel)]="lastDividendAmount"
            (ngModelChange)="inputHandler($event)"
            [ngModelOptions]="{standalone: true}"
            class="param-value"
            data-id="lastDividendAmount"
          >
        </div>

        <div class="param">
        <span class="param-label with-tip">Vola
          <span class="tip">Volatility is a measure of fluctuating change in an instruments price. IV the markets estimate of future volatility derived from forward options specified by the term, counting all days. HV is the realized volatility derived from actual
            movements in the instrument over a period specified by the term, counting only trading days</span>
        </span>

          <div style="display: flex; gap:8px; width:252px;">
            <div style="width: calc(100% - 72px)">
              <iv-live-dropdown
                (closeOtherDropdown)="openDropdown(isFuturesMonitor ? 2 : 1)"
                (selectedDataChange)="selectVolaType($event)"
                [(selectedData)]="volaString"
                [cssClass]="'param-value param-value-style'"
                [data]="isEod == true ? getArrayFromObject(volas): getArrayFromObject(volasDelayed)"
                [label]=""
                [type]="'expirations'"
                [valueAttribute]="'volaString'"
                [dropdownOffset]="{'top': 'auto', 'bottom': '36px'}"
                data-id="volaString"
              >
              </iv-live-dropdown>
            </div>
            <div style="width: 64px">
              <input
                (input)="onVolaValueInput($event, 'vola');inputHandler($event)"
                (keydown)="keyDown($event)"
                (keypress)="onlyNumberKey($event)"
                class="param-value expiry-hours-value"
                data-id="vola"
                value="{{vola}}"
              >
            </div>
          </div>
        </div>

        <div
          *ngIf="!isFuturesMonitor"
          [style.visibility]="(stockType === 'I' || stockType === 'X')? 'hidden': 'visible'"
          class="param"
        >
        <span class="param-label with-tip">DivFreq
          <span class="tip">Dividend Frequency. Stock dividend frequency</span>
        </span>
          <iv-live-dropdown
            (closeOtherDropdown)="openDropdown(isFuturesMonitor ? 3 : 2)"
            (selectedDataChange)="selectFrequency($event)"
            [(selectedData)]="dividendFrequencyName"
            [cssClass]="'param-value param-value-style'"
            [data]="getArrayFromObject(frequencies)"
            [label]=""
            [valueAttribute]="'name'"
            [dropdownOffset]="{'top': 'auto', 'bottom': '36px'}"
            data-id="dividendFrequencyName"
          >
          </iv-live-dropdown>
        </div>

        <div
          *ngIf="!isFuturesMonitor && stockType !== 'S' && stockType !== 'F'"
          [style.visibility]="(stockType === 'S' || stockType === 'F')? 'hidden': 'visible'"
          class="param"
        >
        <span class="param-label with-tip">DivYield
          <span class="tip">Dividend yield for indices</span>
        </span>
          <input
            (input)="onlyNumbersPaste($event)"
            (keydown)="keyDown($event)"
            (keypress)="onlyNumberKey($event)"
            class="param-value"
            data-id="yield"
            value="{{_yield}}"
          >
        </div>

      </div>

      <div class="calculator-right">
        <div class="p-form">
          <div class="p-block">
            <span class="with-tip">P1
              <span class="tip">
                Probability of Touching refers to how likely it is that your futures will at least reach the target price, at any point during the time frame you selected. Compare these figures with the below numbers regarding the chances of the underlying finishing above, below or between your price targets, on the last day of your time period
              </span>
            </span>
            <input
              (input)="onlyNumbersPaste($event)"
              (keydown)="keyDown($event)"
              (keypress)="onlyNumberKey($event)"
              [(ngModel)]="p1"
              [ngModelOptions]="{standalone: true}"
              class="param-value"
              data-id="p1"
            >
          </div>
          <span class="with-tip">P2
            <span class="tip">
              Probability of Touching refers to how likely it is that your futures will at least reach the target price, at any point during the time frame you selected. Compare these figures with the below numbers regarding the chances of the underlying finishing above, below or between your price targets, on the last day of your time period
            </span>
          </span>
          <div class="p-block">
            <input
              (input)="onlyNumbersPaste($event)"
              (keydown)="keyDown($event)"
              (keypress)="onlyNumberKey($event)"
              [(ngModel)]="p2"
              [ngModelOptions]="{standalone: true}"
              class="param-value"
              data-id="p2"
            >
          </div>
          <button
            (click)="calculate()"
            statistic
            statisticElementName="Click probability calculator calculate"
            id="probabilityCalculatorButton"
          >
            Confirm
          </button>
        </div>

        <div class="calculator-result">
          <div class="calculator-result-title">
            Probabilities at the Future Date of the Underlying
          </div>
          <div class="result-items">
            <div class="result-items__item">
              <div class="result-items__text">
                Below Price 1
              </div>
              <div class="result-items__value">
                {{ calculateBelow }}
              </div>
            </div>
            <div class="result-items__item">
              <div class="result-items__text">
                Btw Price 1 & Price 2
              </div>
              <div class="result-items__value">
                {{ calculateBetween }}
              </div>
            </div>
            <div class="result-items__item">
              <div class="result-items__text">
                Above Price 2
              </div>
              <div class="result-items__value">
                {{ calculateAbove }}
              </div>
            </div>
          </div>

          <div class="calculator-result-title">
            Probability of Touching
          </div>
          <div class="result-items">
            <div class="result-items__item">
              <div class="result-items__text">
                Price 1
              </div>
              <div class="result-items__value">
                {{ calculateP1 * 100 | number:'1.0-2' }}%
              </div>
            </div>
            <div class="result-items__item">
              <div class="result-items__text">
                Price 2
              </div>
              <div class="result-items__value">
                {{ calculateP2 * 100 | number:'1.0-2' }}%
              </div>
            </div>
            <div class="result-items__item">
              <div class="result-items__text">
                Both
              </div>
              <div class="result-items__value">
                {{ calculateBoth * 100 | number:'1.0-2' }}%
              </div>
            </div>
            <div class="result-items__item">
              <div class="result-items__text">
                Either
              </div>
              <div class="result-items__value">
                {{ calculateEither * 100 | number:'1.0-2' }}%
              </div>
            </div>
            <div class="result-items__item">
              <div class="result-items__text">
                Neither
              </div>
              <div class="result-items__value">
                {{ calculateNeither * 100| number:'1.0-2' }}%
              </div>
            </div>
          </div>

          <div class="calculator-result-title">
            Underlying Prices for each Standard Deviation Interval at the Future Date
          </div>
          <div class="result-items result-prices">
            <div class="result-items__item">
              <div class="result-items__text">
                -3
              </div>
              <div class="result-items__value" [title]="calculateNegativeStd3">
                {{ calculateNegativeStd3 }}
              </div>
            </div>
            <div class="result-items__item">
              <div class="result-items__text">
                -2
              </div>
              <div class="result-items__value" [title]="calculateNegativeStd2">
                {{ calculateNegativeStd2 }}
              </div>
            </div>
            <div class="result-items__item">
              <div class="result-items__text">
                -1
              </div>
              <div class="result-items__value" [title]="calculateNegativeStd1">
                {{ calculateNegativeStd1 }}
              </div>
            </div>
            <div class="result-items__item">
              <div class="result-items__text">
                +1
              </div>
              <div class="result-items__value" [title]="calculateStd1">
                {{ calculateStd1 }}
              </div>
            </div>
            <div class="result-items__item">
              <div class="result-items__text">
                +2
              </div>
              <div class="result-items__value" [title]="calculateStd2">
                {{ calculateStd2 }}
              </div>
            </div>
            <div class="result-items__item">
              <div class="result-items__text">
                +3
              </div>
              <div class="result-items__value" [title]="calculateStd3">
                {{ calculateStd3 }}
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  </iv-live-common-calculator>

</div>
